<div class="image-holder">
    <img
        src="https://eqao.vretta.com/authoring/user_uploads/2329038/authoring/test-window-icon/1666377674742/test-window-icon.png">
</div>
<div class="table-holder">
    <div class="lead">Administration Windows</div>
    <div class="space-between">
        <div>Select an administration window to access further details</div>
        <div>
            <mat-slide-toggle [(ngModel)]="isShowQA" (change)="qaToggleChanged()" data-ui-name="Is Show QA mat slide toggle" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-is-show-qa-mat-slide-toggle">
                Show QA? ({{isShowQA ? 'Yes' : 'No'}})
            </mat-slide-toggle>
        </div>
        <div class="select">
            <select [(ngModel)]="selectedAcademicYear" (ngModelChange)="testWindowsChanged()" data-ui-name="Selected Academic Year" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-selected-academic-year">
                <option [ngValue]="SELECT_OPTIONS.ALL" data-ui-name="All Windows — selected Academic Year" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-all-windows-selected-academic-year">
                    All Windows
                </option>
                <option *ngFor="let academicYear of academicYears" [ngValue]="academicYear" data-ui-name="Render Academic Year(academic Year) — selected Academic Year" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-render-academic-year-academic-year-selected-academic-year">
                    {{renderAcademicYear(academicYear)}}
                </option>
                <option [ngValue]="SELECT_OPTIONS.OTHER" data-ui-name="Other — selected Academic Year" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-other-selected-academic-year">Other</option>
            </select>
        </div>
    </div>
    <table style="width: auto;" data-ui-name="Panel test window table table" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-panel-test-window-table-table">
        <tr data-ui-name="ID headings row" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-id-headings-row">
            <th>ID</th>
            <th>Window Title</th>
            <th>Dates</th>
            <!-- <th>Status</th> -->
            <th *ngIf="!isTwSelectDisabled">Select</th>
            <th>Scoring Window Ids</th>
        </tr>
        <ng-container *ngFor="let window of visibleTestWindows">
            <tr *ngIf="true" data-ui-name="Window id values row" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-window-id-values-row" [attr.data-entity-key]="window.id" data-entity-type="window">
                <td>{{window.id}}</td>
                <td>
                    <div>
                        <strong>{{renderTwTitle(window.title)}}</strong>
                    </div>
                    <div class="space-between">
                        <div>
                            <code>{{window.type_slug}}</code>
                            <code style="color: blue">{{window.test_ctrl_group_id}}</code>
                            <span *ngIf="window.is_qa==1" class="tag is-danger">QA</span>
                        </div>
                        <div style="font-size: 0.8em;">
                            <a [routerLink]="getTestWindowRoute(window)" *ngIf="!hideEdits" data-ui-name="Edit" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-edit" [attr.data-entity-key]="window.id" data-entity-type="window">
                                Edit
                            </a>
                        </div>
                    </div>
                </td>
                <td>{{renderDate(window.date_start)}} to {{renderDate(window.date_end)}}</td>
                <!-- <td>{{window.status}}</td> -->
                <td *ngIf="!isTwSelectDisabled">
                    <ng-container [ngSwitch]="!!checkActiveWindow(window)">
                        <button *ngSwitchCase="true" class="button is-small is-info" data-ui-name="Selected" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-selected" [attr.data-entity-key]="window.id" data-entity-type="window">
                            Selected
                        </button>
                        <button *ngSwitchCase="false" class="button is-small" (click)="selectTestWindowFocus(window)" data-ui-name="Not Selected" data-ui-component="panel-test-window-table" data-testid="panel-test-window-table-not-selected" [attr.data-entity-key]="window.id" data-entity-type="window">
                            Not Selected
                        </button>
                    </ng-container>
                </td>
                <td>
                    {{window.marking_window_id}}
                </td>
            </tr>
        </ng-container>
    </table>
    <p *ngIf="qaHiddenHint" class="help" role="status" data-testid="tc-qa-hidden-hint" style="margin: 0.6rem 0;" data-ui-name="Qa Hidden Hint" data-ui-component="panel-test-window-table">{{qaHiddenHint}}</p>
    <ng-content></ng-content>
</div>